import type React from "react"

/** Cycle keyboard focus through editable inputs within a form or other container. */
export const cycleFormInputs: React.KeyboardEventHandler<HTMLElement> = (event) => {
  if (event.key !== "Tab") return

  const inputs = Array.from(
    event.currentTarget.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>(
      'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([disabled]), textarea:not([disabled])'
    )
  ).filter((input) => input.getClientRects().length > 0 && !input.readOnly)

  if (inputs.length === 0) return

  event.preventDefault()
  const currentIndex = inputs.indexOf(event.target as HTMLInputElement | HTMLTextAreaElement)
  const nextIndex =
    currentIndex < 0
      ? event.shiftKey
        ? inputs.length - 1
        : 0
      : (currentIndex + (event.shiftKey ? -1 : 1) + inputs.length) % inputs.length
  inputs[nextIndex]?.focus()
}
